// removed by extract-text-webpack-plugin
module.exports = {"buttons":"trash-multiple-documents__buttons___37WWv"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/trash-multiple-documents.scss
// module id = 515
// module chunks = 0